let basePath = '';
let basePathApp = '';
let basePathPublic = '';
let pathToPrivateStaticImages = '';
let pathToPublicStaticImages = '';
let isLocalhost;

const managerHybridLocalhost = 'localhost:4242';
const managerPublicHybridLocalhost = 'localhost:4222';

if (window.location.host === managerHybridLocalhost || window.location.host === managerPublicHybridLocalhost) {
    // isolated local development
    basePath = '';
    basePathApp = '';
    basePathPublic = '';
    pathToPrivateStaticImages = '/assets/static-images';
    pathToPublicStaticImages = '/assets/static-images';
    isLocalhost = true;
} else {
    const pathArray = window.location.pathname.split('/');
    // monolithic IIS served, assume our mount path is {host}/manager/app
    basePath = `/${pathArray[1]}`;

    basePathApp = `${basePath}/app`;
    basePathPublic = `${basePath}/public`;
    pathToPrivateStaticImages = '/Manager/client/static-images';
    pathToPublicStaticImages = '/Manager/client/public/static-images';
    isLocalhost = false;
}

export const BASE_PATH = `${basePath}`,
    BASE_PATH_API = `${basePath}/api`,
    BASE_PATH_APP = basePathApp,
    BASE_PATH_PUBLIC = basePathPublic,
    FILE_DOWNLOAD_BASE = `${basePath}/api/files/download?fileId=`,
    LOGIN_PATH = `${BASE_PATH_PUBLIC}/authentication/login`,
    STATIC_IMAGES_PATH = pathToPrivateStaticImages,
    STATIC_IMAGES_PUBLIC_PATH = pathToPublicStaticImages,
    IS_LOCALHOST = isLocalhost,
    HYBRID_LOCALHOST = managerHybridLocalhost,
    PUBLIC_HYBRID_LOCALHOST = managerPublicHybridLocalhost;
